import type { z } from 'zod';

import type { LessonTemplateSchema } from './schemas';

type LessonTemplateField = keyof z.infer<typeof LessonTemplateSchema>;

const listAttributes = [
  'id',
  'courseId',
  'code',
  'active',
  'lessonGroup',
  'label',
  'lessonType',
  'isTimesheeted',
  'homeworkRequired',
  'sortOrder',
  'permissionIds',
] as const satisfies readonly LessonTemplateField[];

const getAttributes = [
  ...listAttributes,
  'duration',
  'questionSetId',
] as const satisfies readonly LessonTemplateField[];

const updateAttributes = [
  'label',
  'lessonType',
  'lessonGroup',
  'isTimesheeted',
  'homeworkRequired',
  'active',
  'questionSetId',
] as const satisfies readonly LessonTemplateField[];

export const LessonTemplateAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
